import * as React from 'react';

import { getWebview } from '@cian/webview/webview';

import { DesktopView } from '../../components/ShareReport';
import { trackLinkReportCopy, trackLinkReportClick } from './tracking';
import { useIsClipboardVisible } from '../../utils/webview';

export interface IShareReportDesktopProps {
  url: string;
  isWebview: boolean;
}

export const ShareReportDesktop: React.FC<IShareReportDesktopProps> = ({ url, isWebview }) => {
  const isVisibleClipboard = useIsClipboardVisible();
  const onHanldeDesktopClick = React.useCallback(() => {
    if (isWebview) {
      const webview = getWebview();
      webview.sendAction({
        action: 'valuationForAgentReport.writeText',
        payload: { url },
      });
    } else {
      window.navigator.clipboard.writeText(url);
    }

    trackLinkReportCopy();
  }, [url, isWebview]);

  return (
    <DesktopView
      url={url}
      isVisibleClipboard={isVisibleClipboard}
      onClick={onHanldeDesktopClick}
      onFocus={trackLinkReportClick}
    />
  );
};

ShareReportDesktop.displayName = 'ShareReportDesktop';
